import { Component, computed, effect, input, model } from "@angular/core"
import { NgClass } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { FormValueControl } from "@angular/forms/signals"
import { Observable } from "rxjs"

@Component({
    selector: "valben-text-input",
    templateUrl: "./text-input.component.html",
    standalone: true,
    imports: [NgClass, FormsModule],
})
export class TextInputComponent implements FormValueControl<string> {
    value = model("")
    title = input("")
    placeholder = input("")
    error = input(false)
    invalid = input(false)
    disabled = input(false)
    preview = input(false)

    hasError = computed(() => this.error() || this.invalid())
    isBlank = computed(() => this.value().trim() === "")

    key = input("")
    itemObservable = input<(() => Observable<any> | undefined) | undefined>(undefined)
    update = input<((value: any) => void) | undefined>(undefined)

    constructor() {
        effect(onCleanup => {
            const sub = this.itemObservable()?.()?.subscribe(item => {
                if (item == null) return
                this.value.set(item[this.key()] ?? "")
            })
            onCleanup(() => sub?.unsubscribe())
        })
    }

    onValueChange(next: string | null): void {
        const value = next ?? ""
        this.value.set(value)
        this.update()?.(value)
    }
}
